import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TypeMappingNewsOutput } from '@shared/api/middleware/mappingAPI/news/type'
import { TypeMappingRestOutput } from '@shared/api/middleware/mappingAPI/restaurant/type'
import { newsItemInitialState } from '@pages/NewsItem/model/initialState'

const newsItem = createSlice({
  name: 'newsItem',
  initialState: newsItemInitialState,

  reducers: {
    setNews(state, action: PayloadAction<TypeMappingNewsOutput>) {
      state.news = action.payload
    },
    setRestaurantsList(state, action: PayloadAction<TypeMappingRestOutput[] | []>) {
      state.restaurants = action.payload?.length ? action.payload : null
    },
    setOthersNewsList(state, action: PayloadAction<TypeMappingNewsOutput[]>) {
      state.others = action.payload
    },
    resetState() {
      return newsItemInitialState
    },
  },
})

export const { setNews, setRestaurantsList, setOthersNewsList, resetState } = newsItem.actions
export default newsItem.reducer
